import { StockModuleLayout } from "@features/stock";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock")({
  staticData: {
    title: "Stock",
    permission: PERMISSIONS.STOCK.DASHBOARD.VIEW,
    module: "stock",
    section: "Stock",
    order: 45,
    showInNav: false,
  },
  component: StockModuleLayout,
});
